import classNames from 'classnames';
import styles from './select.module.scss';

export enum RsSelectSize {
  LARGE = 'large',
  MEDIUM = 'medium',
  SMALL = 'small',
}

export const sizeMap = {
  [RsSelectSize.LARGE]: classNames(styles.size, styles.large),
  [RsSelectSize.MEDIUM]: classNames(styles.size, styles.medium),
  [RsSelectSize.SMALL]: classNames(styles.size, styles.small),
};
